module.exports = __webpack_public_path__ + "img/bazarImage.c532dbab.svg";